import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
	selector: 'app-moniepoint-check-box',
	templateUrl: './moniepoint-check-box.component.html',
	styleUrls: ['./moniepoint-check-box.component.scss']
})
export class MoniepointCheckBoxComponent implements OnInit {
	@Input() value = false;
	@Input() id: any = 'checkbox';
	@Input() isReadOnly: boolean;
	@Output() checked = new EventEmitter();
	@Input() type: KamonaCheckboxType;
	readonly NEW_TYPE = KamonaCheckboxType.SECONDARY;
	readonly DEFAULT_TYPE = KamonaCheckboxType.PRIMARY;
	initialValue: boolean;

	constructor() {
	}

	ngOnInit(): void {
		this.initialValue = this.value;
		this.type = this.type || this.DEFAULT_TYPE;
	}

	setReadOnlyCheckBox($event) {
		$event.preventDefault();
		this.value = this.initialValue;
		this.checked.emit($event);
	}

	setCheckBox($event) {
		this.checked.emit($event);
	}
}

export enum KamonaCheckboxType {
	PRIMARY = 'PRIMARY',
	SECONDARY = 'SECONDARY',
	DEFAULT = 'DEFAULT'
}
